import {
  StyleSheetManager as OriginalStyleSheetManager,
  StyleSheetManagerProps
} from 'styled-components';

export function StyleSheetManager(props: StyleSheetManagerProps) {
  if (typeof window !== 'undefined') {
    return props.children;
  }
  return (
    <OriginalStyleSheetManager {...props} />
  );
}
